import React, { useState, useEffect } from "react";
import { Button, Input, Form, Select, Row, Col, Space, Tooltip } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import leftArrow from "../../../assets/images/LeftArrow.svg";
import { toast } from "react-toastify";
import UserIcon from "../../../assets/images/user-icon.svg";
import { getFormFieldValue } from "../../../utils/index";
import ImageLabel from "../../image-label";
import { formatData } from "../../../utils/formatData";
import { useStore } from "../../../store";
import "../index.scss";
import ModalMediaPlayer from "../../videoPlayer/modalPlayer";
import { useConnectsUForm } from "../../../custom-hooks/useConnectsUForm";
import { setUpdatedValues } from "../../../store/actions";
import { useTab } from "../../../custom-hooks/useTab";
import PlusIcon from "../../../assets/images/plus-icon.svg";
import QuestionIcon from "../../../assets/images/question-icon.svg";

const { TextArea } = Input;

export default function AddHelp() {
  const navigate = useNavigate();
  const { state } = useLocation() || {};
  const [mediatype, setmediatype] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const whichTab = "help";
  const { updateImage } = useConnectsUForm();
  const { updatedValues, dispatch } = useStore();
  const [formChanged, setFormChanged] = useState(false);
  const { callMicroServices } = useTab();
  const [userRole, setUserRole] = useState();

  useEffect(() => {
    setUserRole(state.userRole);
  }, [state.userRole]);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, "help", i, key);
  };

  const SelectChangeHandler = (e, i) => {
    // form.setFieldValue(["help", i, "mediaLink", "mediaType"], e);

    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
  };

  const fieldsChange = (fields) => {
    if (fields && fields.length === 1) {
      const getNames = fields[0].name;

      const nameModified =
        getNames[0] === "corousel" ? "corousel" : getNames[0];
      var prev = updatedValues;

      const prevItems = prev[nameModified];

      if (prevItems) {
        const names = [...prevItems, getNames[1]];
        const removeDuplicates = names.filter(function (
          item,
          index,
          inputArray
        ) {
          return inputArray.indexOf(item) == index;
        });
        prev[nameModified] = removeDuplicates;
      } else {
        prev[nameModified] = [getNames[1]];
      }

      const getAllField = form.getFieldsError();

      dispatch(setUpdatedValues(prev));
    }
  };

  const handleUpdateItem = async (data) => {
    console.log("onfinish data", data["help"]);
    let headerList = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    let existingData = [],
      newData = [];
    if (data["help"]) {
      data["help"].map((item) => {
        if (item.id) {
          existingData.push(item);
        } else {
          newData.push(item);
        }
      });
      if (userRole) {
        // console.log("updated", updatedValues)
        const formattedData = formatData(
          "help",
          data["help"],
          updatedValues,
          userRole
        );
        if (Object.keys(formattedData).length > 0) {
          dispatch(setUpdatedValues({}));
          const response = await callMicroServices("help", formattedData, form);

          if (response) {
            setFormChanged(false);
            navigate("/admin", { state: { reload: true } });
          }
          // setTimeout(() => {
          //   getHelpInfo();
          // }, 2000);
        } else {
          toast.error("Nothing to update");
        }
      }
    }
  };

  return (
    <div>
      <div
        className="heading-backBtn"
        onClick={() => {
          navigate("/admin", { state: { reload: false } });
          sessionStorage.removeItem("helpDataResponse");
        }}
      >
        <img style={{ marginRight: "8px" }} src={leftArrow} alt="leftarrow" />
        Add Help
      </div>


      <div className="edit-video-container multipalFormStyle">
        <Form
          name="control-hooks"
          className="organizationForm"
          form={form}
          autoComplete="off"
          labelCol={{ span: 5 }}
          onFinish={handleUpdateItem}
          onFieldsChange={fieldsChange}
        >
          <div className="multipalFormRow">
            <div className="multipalFormCol">
              <Form.List name="help" initialValue={[""]}>
                {(fields, { add, remove }) => (
                  <>
                    <div className="formListRow">
                      <div className="formListCol">
                        <div style={{ textAlign: "right" }}>
                          <Button className="redBtn" onClick={() => add()}>
                            <img
                              src={PlusIcon}
                              alt="plusIcon"
                              style={{ marginRight: "5px" }}
                            />
                            Add More
                          </Button>
                        </div>
                      </div>
                    </div>
                    {fields.map(({ key, name, ...restField }, i) => (

                      <div className="formListRow">
                        <div className="formListCol">
                          <Form.Item
                            {...restField}
                            className="edit-videos-title"
                            label="Title"
                            name={[name, "title"]}
                            rules={[
                              {
                                required: true,
                                message: "Title is required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Title"
                              maxLength={30}
                              showCount
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            className="edit-videos-title"
                            label="Description"
                            name={[name, "description"]}
                            rules={[
                              {
                                required: true,
                                message: "Description is required",
                              },
                              {
                                validator: (_, value) => {
                                  if (value && value.length > 400) {
                                    return Promise.reject(
                                      new Error("Description cannot exceed 400 characters")
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <TextArea
                              placeholder="Description"
                              rows={3}
                              showCount
                              maxLength={400} // allow typing more, validator will catch >400
                            />
                          </Form.Item>

                          <div className="d-flex">
                            <Form.Item
                              {...restField}
                              name={[name, "mediaLink", "mediaType"]}
                              className="edit-videos-title"
                              style={{ minWidth: "100%", display: "block" }}
                              labelCol={{ span: 5 }}
                              label="Image/Video"
                              rules={[
                                {
                                  required: true,
                                  message: "Select any option",
                                },
                              ]}
                            >
                              <Select
                                onChange={(value) => {
                                  form.resetFields([[name, "mediaLink"]]);
                                  // ✅ Reset the entire mediaLink object for this row
                                  form.setFieldsValue({
                                    [name]: {
                                      mediaLink: {
                                        mediaType: value, // only new type
                                        url: undefined,   // clear YouTube/Vimeo
                                        blob: undefined,  // clear uploaded image
                                      },
                                    },
                                  });

                                  SelectChangeHandler(value, i);
                                }}
                                placeholder="Select Option"
                              >
                                <Select.Option value="VIMEO_MEDIA">Add Vimeo Link</Select.Option>
                                <Select.Option value="SOCIAL_MEDIA">Add Youtube Link</Select.Option>
                                <Select.Option value="SYNTHESIA_MEDIA">Add Synthesia Link</Select.Option>
                                <Select.Option value="IMAGE">Upload Image</Select.Option>
                              </Select>
                            </Form.Item>
                          </div>

                          {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                            <Form.Item
                              label="Youtube Link"
                              {...restField}
                              name={[name, "mediaLink", "url"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Youtube link is required",
                                },
                                {
                                  validator: (_, value) => {
                                    if (!value) return Promise.resolve();
                                    const youtubeRegex =
                                      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
                                    return youtubeRegex.test(value)
                                      ? Promise.resolve()
                                      : Promise.reject(new Error("Enter a valid value"));
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="Youtube Link" />
                            </Form.Item>
                          ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                            <Form.Item
                              label="Vimeo Link"
                              {...restField}
                              name={[name, "mediaLink", "url"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vimeo link is required",
                                },
                                {
                                  validator: (_, value) => {
                                    if (!value) return Promise.resolve();
                                    const vimeoRegex =
                                      /^(https?:\/\/)?(www\.)?vimeo\.com\/\d+$/;
                                    return vimeoRegex.test(value)
                                      ? Promise.resolve()
                                      : Promise.reject(new Error("Enter a valid value"));
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="Vimeo Link" />
                            </Form.Item>
                          ) : findValue(i, "type") === "IMAGE" ? (
                            <Form.Item
                              {...restField}
                              label={<ImageLabel label={"Image"} />}
                              colon={false}
                              name="mediaLink"
                              className="experienceImg"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    return findValue(i, "blob")
                                      ? Promise.resolve()
                                      : findValue(i, "url")
                                        ? Promise.resolve()
                                        : Promise.reject(
                                          new Error("Enter a valid value")
                                        );
                                  },
                                },
                              ]}
                            >
                              {findValue(i, "blob") ? (
                                <img
                                  src={URL.createObjectURL(
                                    findValue(i, "blob")
                                  )}
                                  alt=""
                                  style={{
                                    maxHeight: "120px",
                                    width: "300px",
                                    border: "1px solid #A5A5A5",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    marginBottom: "-10px",
                                    marginRight: "10px",
                                  }}
                                />
                              ) : findValue(i, "url") ? (
                                <img
                                  src={findValue(i, "url")}
                                  alt=""
                                  style={{
                                    maxHeight: "120px",
                                    width: "300px",
                                    border: "1px solid #A5A5A5",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    marginBottom: "-10px",
                                    marginRight: "10px",
                                  }}
                                />
                              ) : (
                                <img
                                  src={UserIcon}
                                  style={{
                                    maxHeight: "80px",
                                    marginRight: "10px",
                                    marginBottom: "-15px",
                                  }}
                                />
                              )}

                              <label
                                name="file"
                                className="fileUploadBtn redBtn"
                                style={{ padding: "8px" }}
                              >
                                {" "}
                                Upload Image
                                <input
                                  accept="image/png, image/gif, image/jpeg"
                                  type="file"
                                  style={{ display: "none" }}
                                  // required={true}
                                  onChange={(e) =>
                                    updateImage(e, i, form, whichTab)
                                  }
                                />
                              </label>
                              <Tooltip
                               className="question"
                                  title={
                                    "Recommended image dimensions: 1280x720 pixels"
                                  }
                                >
                                  <img
                                    src={QuestionIcon}
                                    alt="question-icon"
                                  />
                                </Tooltip>
                            </Form.Item>
                          ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                            <Form.Item
                              label="Synthesia Link"
                              labelCol={{ span: 5 }}
                              {...restField}
                              name={[name, "mediaLink", "url"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Synthesia  link is required",
                                },

                              ]}
                            >
                              <Input />
                            </Form.Item>
                          ) : null}

                          <Form.Item
                            {...restField}
                            className="edit-videos-title"
                            label={<span style={{ marginLeft: '10px' }}>Web Link</span>}
                            name={[name, "webLink"]}
                            rules={[
                              {
                                required: false,
                                message: "Web link is required",
                              },
                              {
                                validator: (_, value) => {
                                  if (!value) return Promise.resolve();

                                  // Generic URL regex
                                  const urlRegex =
                                    /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;

                                  return urlRegex.test(value)
                                    ? Promise.resolve()
                                    : Promise.reject(new Error("Enter a valid web link"));
                                },
                              },
                            ]}
                          >
                            <Input placeholder="Web link" onChange={(e) => {
                              const value = e.target.value;

                              if (value.length > 200) {
                                toast.warn("Weblink should not exceed 200 characters");

                                form.setFieldValue(
                                  [whichTab, name, "webLink"],
                                  value.slice(0, 200)
                                );
                              }
                            }} />
                          </Form.Item>

                          <div className="d-flex">
                            {userRole === "ORGANIZATION_ADMIN" ? (
                              <Form.Item
                                {...restField}
                                style={{
                                  minWidth: "100%",
                                  display: "block",
                                }}
                                className="edit-videos-title"
                                label="Asset Type"
                                name={[name, "assetTypeEnum"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Select one asset typefrom list",
                                  },
                                ]}
                              >
                                <Select
                                  name={[name, "assetTypeEnum"]}
                                  placeholder="Select assetType"
                                >
                                  <Select.Option value="BUSINESS_CARD">
                                    Map Advert
                                  </Select.Option>
                                  <Select.Option value="CAROUSEL">
                                    App Carousel
                                  </Select.Option>
                                  <Select.Option value="ABOUT_US">
                                    About us
                                  </Select.Option>
                                  <Select.Option value="PRODUCT">
                                    Products
                                  </Select.Option>
                                  <Select.Option value="SERVICE">
                                    Services
                                  </Select.Option>
                                  <Select.Option value="CONTRACTS">
                                    Contracts
                                  </Select.Option>
                                  <Select.Option value="CONTACT_US">
                                    Contact us
                                  </Select.Option>
                                  <Select.Option value="APPRENTICESHIP">
                                    Apprenticeships
                                  </Select.Option>
                                  <Select.Option value="VACANCY">
                                    Vacancies
                                  </Select.Option>
                                  <Select.Option value="COURSES">
                                    Our Courses
                                  </Select.Option>
                                  <Select.Option value="WHY_WORK">
                                    Why Work for Us
                                  </Select.Option>
                                  <Select.Option value="TEAMS_AND_ROLES">
                                    Teams and Roles
                                  </Select.Option>
                                  <Select.Option value="WORK_EXPERIENCE">
                                    Experiences of work
                                  </Select.Option>
                                  <Select.Option value="BLOG">
                                    Blog
                                  </Select.Option>
                                  <Select.Option value="IN_THE_PRESS">
                                    In the Press
                                  </Select.Option>
                                  <Select.Option value="GENERIC">
                                    Generic
                                  </Select.Option>
                                </Select>
                              </Form.Item>
                            ) : userRole === "PARTNER_ADMIN" ? (
                              <Form.Item
                                {...restField}
                                className="edit-videos-title"
                                style={{
                                  minWidth: "100%",
                                  display: "block",
                                }}
                                label="Asset Type"
                                name={[name, "assetTypeEnum"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Select one asset typefrom list",
                                  },
                                ]}
                              >
                                <Select
                                  name={[name, "assetTypeEnum"]}
                                  placeholder="Select assetType"
                                >
                                  <Select.Option value="FULL_MEMBERS">
                                    Full Members
                                  </Select.Option>
                                  <Select.Option value="HUB_MEMBERS">
                                    Hub Members
                                  </Select.Option>
                                  <Select.Option value="CAROUSEL">
                                    App Carousel
                                  </Select.Option>
                                  <Select.Option value="SPONSOR_LOGOS">
                                    Sponsor Logos
                                  </Select.Option>
                                  <Select.Option value="ENGAGEMENT_TAB">
                                    Dashboard
                                  </Select.Option>
                                  <Select.Option value="RESTORE_MEMBERS">
                                    Restore Members
                                  </Select.Option>
                                  <Select.Option value="GENERIC">
                                    Generic
                                  </Select.Option>
                                </Select>
                              </Form.Item>
                            ) : userRole === "END_USER" ? (
                              <Form.Item
                                {...restField}
                                className="edit-videos-title"
                                style={{
                                  minWidth: "100%",
                                  display: "block",
                                }}
                                label="Asset Type"
                                name={[name, "assetTypeEnum"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Select one asset typefrom list",
                                  },
                                ]}
                              >
                                <Select
                                  name={[name, "assetTypeEnum"]}
                                  placeholder="Select assetType"
                                >
                                  <Select.Option value="BUSINESS_CARD">
                                    Map Advert
                                  </Select.Option>
                                  <Select.Option value="CAROUSEL">
                                    App Carousel
                                  </Select.Option>
                                  <Select.Option value="ABOUT_US">
                                    About us
                                  </Select.Option>
                                  <Select.Option value="PRODUCT">
                                    Products
                                  </Select.Option>
                                  <Select.Option value="SERVICE">
                                    Services
                                  </Select.Option>
                                  <Select.Option value="CONTRACTS">
                                    Contracts
                                  </Select.Option>
                                  <Select.Option value="CONTACT_US">
                                    Contact us
                                  </Select.Option>
                                  <Select.Option value="APPRENTICESHIP">
                                    Apprenticeships
                                  </Select.Option>
                                  <Select.Option value="VACANCY">
                                    Vacancies
                                  </Select.Option>
                                  <Select.Option value="COURSES">
                                    Our Courses
                                  </Select.Option>
                                  <Select.Option value="WHY_WORK">
                                    Why work for us
                                  </Select.Option>
                                  <Select.Option value="TEAMS_AND_ROLES">
                                    Teams and roles
                                  </Select.Option>
                                  <Select.Option value="WORK_EXPERIENCE">
                                    Experiences of work
                                  </Select.Option>
                                  <Select.Option value="BLOG">
                                    Blog
                                  </Select.Option>
                                  <Select.Option value="IN_THE_PRESS">
                                    In the Press
                                  </Select.Option>
                                  <Select.Option value="FULL_MEMBERS">
                                    Full Members
                                  </Select.Option>
                                  <Select.Option value="HUB_MEMBERS">
                                    Hub Members
                                  </Select.Option>
                                  <Select.Option value="SPONSOR_LOGOS">
                                    Sponsor Logos
                                  </Select.Option>
                                  <Select.Option value="ENGAGEMENT_TAB">
                                    Dashboard
                                  </Select.Option>
                                  <Select.Option value="RESTORE_MEMBERS">
                                    Restore Members
                                  </Select.Option>
                                  <Select.Option value="HOME">
                                    Home
                                  </Select.Option>
                                  <Select.Option value="FAVORITES">
                                    Favorites
                                  </Select.Option>
                                  <Select.Option value="ORGANIZATION_LOGIN">
                                    + Organization
                                  </Select.Option>
                                  <Select.Option value="EDIT_PROFILE">
                                    Edit Profile
                                  </Select.Option>
                                  <Select.Option value="MICROSITES">
                                    Microsites
                                  </Select.Option>
                                  <Select.Option value="USER_LOGIN">
                                    User Login
                                  </Select.Option>
                                  <Select.Option value="SEARCH_AND_FILTERS">
                                    Search and Filters
                                  </Select.Option>
                                  <Select.Option value="VIEWS">
                                    Views
                                  </Select.Option>
                                  <Select.Option value="GENERIC">
                                    Generic
                                  </Select.Option>
                                </Select>
                              </Form.Item>
                            ) : null}
                            <Form.Item style={{ marginLeft: "5px" }}>
                              <div className="edit-remove-btn">
                                <Tooltip
                                  title={
                                    "For which section this help content needs to be displayed"
                                  }
                                >
                                  <img
                                    src={QuestionIcon}
                                    alt="question-icon"
                                  />
                                </Tooltip>
                              </div>
                            </Form.Item>
                          </div>
                        </div>
                      </div>

                    ))}
                    <div className="formListRow">
                      <div className="formListCol">
                        <div className="inputBody">
                          <label></label>
                          <div style={{ textAlign: "right" }}>
                            {fields && fields.length <= 1 ? (
                              <></>
                            ) : (
                              <Button
                                className="clear-btn"
                                type="button"
                                style={{ margin: "20px 0" }}
                                onClick={() => {
                                  const itemsToRemove = [];
                                  fields.forEach((f, i) => {
                                    if (!findValue(i, "id") && i !== 0) {
                                      itemsToRemove.push(f.name);
                                    }
                                  });
                                  if (itemsToRemove.length > 0) {
                                    remove(itemsToRemove);
                                  }
                                }}
                              >
                                Cancel
                              </Button>
                            )}
                            {formChanged ? (
                              <Button
                                className="saveBtn redBtn"
                                style={{ margin: "20px 10px" }}
                                onClick={() => {
                                  form.submit();
                                }}
                              >
                                Save All
                              </Button>
                            ) : (
                              <Button
                                className="saveBtn redBtn"
                                style={{
                                  opacity: "0.5",
                                  pointerEvents: "none",
                                  margin: "0 10px",
                                }}
                              >
                                Save All
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>


                  </>
                )}
              </Form.List>
            </div>
          </div>
        </Form>
      </div>

      {isModalOpen ? (
        <ModalMediaPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediatype}
        />
      ) : (
        ""
      )}
    </div>
  );
}
